import { render, staticRenderFns } from "./perspective-2030.vue?vue&type=template&id=63f14cbc&scoped=true"
import script from "./perspective-2030.vue?vue&type=script&lang=js"
export * from "./perspective-2030.vue?vue&type=script&lang=js"
import style0 from "./perspective-2030.vue?vue&type=style&index=0&id=63f14cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f14cbc",
  null
  
)

export default component.exports